export const getRoles = (state) => state.roles
export const getMetaData = (state) => state.metaData
export const getAllRoles = (state) => state.allRoles






